@charset "UTF-8";

/* src/app/pages/qpcr-result-page/qpcr-result-page.component.scss */
.main-div {
  height: 30vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
.table-container {
  overflow-x: auto;
  max-width: 100%;
}
.custom-table {
  width: 100%;
}
th {
  font-weight: bold;
  background-color: #E6E8EB;
}
table {
  width: 100%;
}
table thead th {
  color: white;
  font-size: 8pt;
  background-color: #3b5998;
}
tr td {
  font-size: 8pt;
}
th,
td {
  border: 1px solid #ddd;
  padding: 0px;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.icon-container {
  display: flex;
  justify-content: space-between;
  margin-top: 5px;
}
.target-container {
  display: flex;
  justify-content: space-between;
  margin-top: 5px;
}
.icon {
  flex: 0.4;
  margin-right: 2px;
}
.comment-box {
  display: flex;
  flex-direction: column;
}
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
input[disabled][type=checkbox]:checked::before {
  content: "\2611";
  position: relative;
  background: white;
  font-size: 17px;
  font-weight: 600;
}
.spinner-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-size: 14px;
  color: #666;
}
.spinner-border {
  margin-right: 8px;
}
.grid-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  padding: 10px;
}
.grid-item {
  width: 100%;
}
.grid-content {
  display: block;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
  padding: 10px;
}
.target-dropdown {
  width: 300px;
  margin-bottom: 1rem;
}
.panel-saved {
  border: 2px solid #4CAF50 !important;
  background-color: #f1fff1 !important;
}
.panel-ql {
  border: 2px solid #00acc1 !important;
  background-color: #e0f7fa !important;
}
.dots-spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 10px;
  gap: 8px;
}
.dot {
  width: 12px;
  height: 12px;
  background-color: #3fb582;
  border-radius: 50%;
  animation: pulse 0.6s infinite ease-in-out;
}
.dot:nth-child(2) {
  animation-delay: 0.2s;
}
.dot:nth-child(3) {
  animation-delay: 0.4s;
}
@keyframes pulse {
  0%, 100% {
    transform: scale(0.8);
    opacity: 0.6;
  }
  50% {
    transform: scale(1.2);
    opacity: 1;
  }
}
::ng-deep .custom-panel-header {
  display: flex !important;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
::ng-deep .header-left {
  font-weight: bold;
}
::ng-deep .header-right {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #2e7d32;
  font-weight: 600;
  white-space: nowrap;
  margin-right: 50px;
}
::ng-deep .mdc-text-field--filled:not(.mdc-text-field--disabled) {
  background-color: white;
}
.spinner {
  width: 20px;
  height: 20px;
  border: 2px solid #5DADE0;
  border-top-color: transparent;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.custom-table th {
  font-weight: bold;
  background-color: #3b5998;
  color: white;
  font-size: 8pt;
  border: 1px solid #ddd;
  padding: 0px;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.custom-table td {
  font-size: 8pt;
  border: 1px solid #ddd;
  padding: 0px;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
::ng-deep .mat-cell,
::ng-deep .mat-header-cell {
  padding: 0 !important;
  margin: 0 !important;
}
/*# sourceMappingURL=qpcr-result-page.component.css.map */
